<template>
    <v-dialog v-model="dialog" width="1600px">
        <v-form ref="txtMltt">
            <v-card>
                <v-card-title class="justify-center">{{ mltp.mltp_nr }} - {{ mltp.mltp_oms }}</v-card-title>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5">
                    <v-col cols=1>Language</v-col> 
                    <v-col cols=11>{{ mltt.taal_code }}</v-col> 
                </v-row>
                <v-row no-gutters class="mx-5">
                    <v-col cols=1>Type</v-col> 
                    <v-col cols=11>{{ mltt.mltt_type }}</v-col> 
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5 mt-3">
                    <v-col cols=1>Subject</v-col> 
                    <v-col cols=11><v-text-field v-model="mltt.mltt_subject" label="Email subject" dense></v-text-field></v-col> 
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5 mt-3">
                    <v-col cols=1>Body text</v-col> 
                    <v-col cols=11><v-textarea v-model="mltt.mltt_txt" rows="20" label="Email body" dense></v-textarea></v-col> 
                </v-row>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="saveMltt(false)">Save</v-btn>
                    <v-btn color="primary" small @click="previewMltt">Preview</v-btn>
                    <v-btn color="primary" small @click="undoMltt">Undo</v-btn>
                    <v-btn color="primary" small @click="closeDialog">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-form> 
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                mltp: "",
                mltt: {},
                undoSubject: "",
                undoBody: "",
            }
        },
        methods: { 
            openDialog(mltp, mltt) {
                this.mltp = mltp;
                this.mltt = mltt;
                this.undoSubject = mltt.mltt_subject;
                this.undoBody = mltt.mltt_txt;
                this.dialog = true;
            },
            undoMltt() {
                console.log(this.undoSubject);
                console.log(this.undoBody);
                this.mltt.mltt_subject = this.undoSubject;
                this.mltt.mltt_txt = this.undoBody;
                this.$store.dispatch('setSnackbar', {
                    showing: true,
                    text: "Text in editor restored, use 'save' to restore to ARES",
                    color: "warning",
                });                
            },
            previewMltt() {
                this.$axios.post("ares/json/ares/syst/mltp/previewMltt.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "previewMltt"
                    },
                    previewMltt: {
                        mltt_encrid: this.mltt.mltt_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        window.open(res.data.previewMltt, '_blank');  
                    }
                })
            },
            saveMltt(close) {
                this.$axios.post("ares/json/ares/syst/mltp/saveMltt.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveMltt"
                    },
                    saveMltt: {
                        mltt: this.mltt
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.saveMltt.text,
                            color: res.data.saveMltt.color
                        });
                        if (close) {
                            this.closeDialog();
                        }
                    }
                })
            },
            closeDialog() {
                this.dialog = false;
            },
        }
    }
</script>

